export default "/build/images/031-4.png?049fb3a0699119b8685968b5497688ab";